const MOCK_PAYMENTS = [
  { id: 1, date: '—', period: '—', hours: '—', amount: '—', status: 'pending' },
  { id: 2, date: '—', period: '—', hours: '—', amount: '—', status: 'pending' },
  { id: 3, date: '—', period: '—', hours: '—', amount: '—', status: 'pending' },
];

const STATUS_MAP: Record<string, { label: string; color: string; bg: string }> = {
  pending: { label: 'Ожидание', color: 'text-accent-200', bg: 'bg-accent-300/10 border-accent-300/20' },
  paid: { label: 'Выплачено', color: 'text-primary-300', bg: 'bg-primary-500/10 border-primary-500/20' },
};

export default function MyPayments() {
  return (
    <div className="max-w-4xl">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-white mb-1">Мои выплаты</h2>
        <p className="text-foreground-500 text-sm">История начислений и выплат</p>
      </div>

      {/* Status banner */}
      <div className="flex items-start gap-3 bg-accent-300/8 border border-accent-300/20 rounded-2xl px-5 py-4 mb-6">
        <span className="w-5 h-5 flex items-center justify-center text-accent-200 flex-shrink-0 mt-0.5">
          <i className="ri-information-line text-base" />
        </span>
        <p className="text-sm text-accent-200 leading-relaxed">
          История выплат будет доступна после завершения оформления и начала работы
        </p>
      </div>

      {/* Stats cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        {[
          { icon: 'ri-wallet-3-line', label: 'Выплачено всего', value: '0 ₽', color: 'text-primary-300', bg: 'bg-primary-500/10' },
          { icon: 'ri-time-line', label: 'В обработке', value: '0 ₽', color: 'text-accent-200', bg: 'bg-accent-300/10' },
          { icon: 'ri-calendar-check-line', label: 'Рабочих часов', value: '0 ч', color: 'text-foreground-700', bg: 'bg-foreground-500/10' },
        ].map((stat) => (
          <div key={stat.label} className="bg-[#0e0e11] border border-[#18181c] rounded-2xl p-5">
            <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${stat.bg} mb-3`}>
              <i className={`${stat.icon} ${stat.color} text-lg`} />
            </div>
            <p className="text-xs text-foreground-400 mb-1">{stat.label}</p>
            <p className={`text-xl font-bold ${stat.color}`}>{stat.value}</p>
          </div>
        ))}
      </div>

      {/* Table */}
      <div className="bg-[#0e0e11] border border-[#18181c] rounded-2xl overflow-hidden">
        <div className="px-6 py-4 border-b border-[#18181c] flex items-center justify-between">
          <h3 className="text-sm font-semibold text-white">История выплат</h3>
          <span className="text-xs text-foreground-400">0 записей</span>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-[#18181c]">
                {['Дата', 'Период', 'Часов', 'Сумма', 'Статус'].map((col) => (
                  <th key={col} className="text-left px-6 py-3 text-xs font-medium text-foreground-400 uppercase tracking-wider">
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {MOCK_PAYMENTS.map((row, i) => {
                const status = STATUS_MAP[row.status];
                return (
                  <tr
                    key={row.id}
                    className={`border-b border-[#18181c]/50 opacity-25 ${i % 2 === 0 ? 'bg-[#141417]/30' : ''}`}
                  >
                    <td className="px-6 py-4 text-sm text-foreground-500">{row.date}</td>
                    <td className="px-6 py-4 text-sm text-foreground-500">{row.period}</td>
                    <td className="px-6 py-4 text-sm text-foreground-500">{row.hours}</td>
                    <td className="px-6 py-4 text-sm text-foreground-500">{row.amount}</td>
                    <td className="px-6 py-4">
                      <span className={`text-xs border rounded-full px-2.5 py-1 ${status.color} ${status.bg}`}>
                        {status.label}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Empty state */}
        <div className="flex flex-col items-center py-14 px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-[#141417] mb-4">
            <i className="ri-wallet-3-line text-3xl text-foreground-300" />
          </div>
          <p className="text-sm font-medium text-foreground-500 mb-1">Данных пока нет</p>
          <p className="text-xs text-foreground-300 max-w-xs">
            Здесь будет отображаться полная история ваших выплат после начала работы
          </p>
        </div>
      </div>
    </div>
  );
}
